import * as React from 'react';

import { observer } from 'mobx-react';

import { Button } from '@estee/elc-buttons';

import { SocialIcon } from '~components/SocialIcon';
import { SignInType } from '~constants/SignInTypeEnum';
import { ButtonStyleType } from '~domain/entities/Config';
import { classes } from '~utils/Classes';
import { useTranslation } from '~utils/hooks/translations';

export interface ISocialButtonProps {
    onClick(): void;
    isFormLoading?: boolean;
    labelKey?: string;
    provider: SignInType;
    buttonStyle?: ButtonStyleType;
    children?: React.ReactNode;
}

export const iconClassNames = classes('icon');
export const labelClassNames = classes('label');

export const SocialButton = observer((props: ISocialButtonProps) => {
    const {
        onClick,
        isFormLoading = false,
        labelKey,
        provider,
        buttonStyle = 'circle',
        children
    } = props;
    let labelContent: React.ReactNode = null;
    if (children) {
        labelContent = children;
    } else {
        labelContent = useTranslation()[labelKey as string];
    }

    return (
        //TODO - APACRIGEL-1730 update buttonStyle and handle it in css instead.
        <Button
            className={classes(`iam-social-button-${provider}`, `iam-social-button-${buttonStyle}`)}
            onClick={onClick}
            disabled={isFormLoading}
        >
            <div className={iconClassNames}>
                <SocialIcon providerName={provider} />
            </div>
            <div className={labelClassNames}>{labelContent}</div>
        </Button>
    );
});
